import React, { useState } from "react";
import amazonPdf from "../../../assets/images/portfolio/caseStudy/Case Study Amazon Replica.pdf";
import goTravelXPdf from "../../../assets/images/portfolio/caseStudy/Case Study Go-TravelX.pdf";
import oxyznPdf from "../../../assets/images/portfolio/caseStudy/Case Study Oxyzn.pdf";
import serenityAIPdf from "../../../assets/images/portfolio/caseStudy/Case Study Serenity AI & Psychometric Evaluation App.pdf";
import startNaukriPdf from "../../../assets/images/portfolio/caseStudy/Case Study Start-Naukri.pdf";
import telepathOSPdf from "../../../assets/images/portfolio/caseStudy/Case StudyTelepath-OS.pdf";
import solaceUnoPdf from "../../../assets/images/portfolio/caseStudy/Solace-UNO Case Study.pdf";
import agriculturePdf from "../../../assets/images/portfolio/caseStudy/AI Case Study- Agriculture Crop.pdf";
import pricePrediction from "../../../assets/images/portfolio/caseStudy/AI Case Study- Bengaluru House Price Prediction.pdf";
import diabetesPdf from "../../../assets/images/portfolio/caseStudy/AI Case Study- Diabetes.pdf";
import iplWinPdf from "../../../assets/images/portfolio/caseStudy/AI Case Study- IPL Win Match Probality.pdf";
import leafDisesasePdf from "../../../assets/images/portfolio/caseStudy/AI Case Study- Leaf Disesase.pdf";
import bdcPdf from "../../../assets/images/portfolio/caseStudy/Case Study - BDC.pdf";
import bharatNFTPdf from "../../../assets/images/portfolio/caseStudy/Case Study - Bharat NFT.pdf";
import cryptolinkX from "../../../assets/images/portfolio/caseStudy/Case Study - CryptolinkX.pdf";
import diamondIndustry from "../../../assets/images/portfolio/caseStudy/Case Study - Diamond Industry.pdf";
import NFTRentalPlace from "../../../assets/images/portfolio/caseStudy/Case Study - NFT Rental Place.pdf";
import sliceLedgerPdf from "../../../assets/images/portfolio/caseStudy/Case Study - SliceLedger.pdf";
import taxiAppPdf from "../../../assets/images/portfolio/caseStudy/Case Study - Taxi App.pdf";
import unpaintedPdf from "../../../assets/images/portfolio/caseStudy/Case Study - Unpainted.pdf";
import HyperledgerPdf from "../../../assets/images/portfolio/caseStudy/Integration of IOT to Hyperledger.pdf";
import { FaFilePdf } from "react-icons/fa";
import LoginCaseStudy from "./LoginCaseStudy";

const caseStudies = [
  {
    title: "Amazon Replica",
    pdfUrl: amazonPdf,
  },
  {
    title: "Go-TravelX",
    pdfUrl: goTravelXPdf,
  },
  {
    title: "Oxyzn",
    pdfUrl: oxyznPdf,
  },
  {
    title: "Serenity AI & Psychometric Evaluation App",
    pdfUrl: serenityAIPdf,
  },
  {
    title: "Start Naukri App",
    pdfUrl: startNaukriPdf,
  },
  {
    title: "Telepath-OS",
    pdfUrl: telepathOSPdf,
  },
  {
    title: "Solace Uno",
    pdfUrl: solaceUnoPdf,
  },
  {
    title: "Agriculture Crop",
    pdfUrl: agriculturePdf,
  },
  {
    title: "Bengaluru House Price Prediction",
    pdfUrl: pricePrediction,
  },
  {
    title: "Diabetes",
    pdfUrl: diabetesPdf,
  },
  {
    title: "IPL Win Match Probality",
    pdfUrl: iplWinPdf,
  },
  {
    title: "Leaf Disesase",
    pdfUrl: leafDisesasePdf,
  },
  {
    title: "Birth/Death Certificate",
    pdfUrl: bdcPdf,
  },
  {
    title: "Bharat NFT",
    pdfUrl: bharatNFTPdf,
  },
  {
    title: "CryptolinkX Exchange",
    pdfUrl: cryptolinkX,
  },
  {
    title: "Diamond Industry",
    pdfUrl: diamondIndustry,
  },
  {
    title: "NFT Rental Place",
    pdfUrl: NFTRentalPlace,
  },
  {
    title: "SliceLedger Protocol",
    pdfUrl: sliceLedgerPdf,
  },
  {
    title:"Taxi App",
    pdfUrl:taxiAppPdf,
  },
    {
    title:"Unpainted",
    pdfUrl:unpaintedPdf,
  },
  {
    title:"Integration of IOT to Hyperledger",
    pdfUrl:HyperledgerPdf
  }
];


export default function CaseStudy() {
  const [showLogin, setShowLogin] = useState(false);
    const [selectedCaseStudy, setSelectedCaseStudy] = useState("");
  
  const handleClick = (caseStudyTitle) => {
    setSelectedCaseStudy(caseStudyTitle);
    setShowLogin(true);
  };
  
  const closePopup = () => setShowLogin(false);
  return (
    <div className="case-study-container">
      <h2 className="heading">Case Studies</h2>

      <div className="case-study-list">
        {caseStudies.map((study, index) => (
          <div key={index} className="case-study-card">
            <div className="case-study-header">
              <FaFilePdf className="pdf-icon" />
              <h2>{study.title}</h2>
            </div>
            <button className="login-btn" onClick={handleClick}>
            Get Case Study
            </button>
          </div>
          
        ))}
        {showLogin && (
                <LoginCaseStudy
                  selectedCaseStudy={selectedCaseStudy}
                  onClose={closePopup}
                  caseStudies={caseStudies}
                />
              )}
      </div>
    </div>
  );
}
